/**
 * アプリケーションエントリーポイント
 *
 * @file main.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * Reactアプリケーションのメインエントリーポイント。ReactDOMでDOMへのレンダリング、
 * BrowserRouterでのURIルーティング、AuthProviderでの認証コンテキストを初期化。
 * 公開表示設定取得後に i18n 初期化（defaultLanguage 注入）し render する。
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import SellerRoutes from './routes/SellerRoutes';
import App from '@shared/App.tsx';
import { initializeI18n } from '@shared/i18n';
import { getPublicDisplaySettings } from './services/api/public-settings.service';
import '@shared/styles/common.css';
import '../public/css/seller.css';
import 'material-icons/iconfont/material-icons.css';
import '@fontsource/noto-sans-jp/300.css';
import '@fontsource/noto-sans-jp/400.css';
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/700.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

getPublicDisplaySettings().then((settings) => {
  return initializeI18n('seller', settings.defaultLanguage).then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <BrowserRouter>
          <App role="seller" notificationDurationSeconds={settings.notificationDefaultDurationSeconds}>
            <SellerRoutes />
          </App>
        </BrowserRouter>
      </React.StrictMode>,
    );
  });
}).catch((err: unknown) => {
  throw err;
});
